import { env } from '@cc-shopping/platform-env';

export const ICON_URL_MAP = {
  checkBoxRounded: `${env.NEXT_PUBLIC_NW_URL}cdn/cc-shopping-client/learn-content/icons/pros-check.svg`,
  disabledRounded: `${env.NEXT_PUBLIC_NW_URL}cdn/cc-shopping-client/learn-content/icons/cons-disabled.svg`,
};

export type IconUrlMapKeys = keyof typeof ICON_URL_MAP;
